import { ILookupsState } from "./lookups.types";

export const initialState: ILookupsState = {
  lookups: [],
  loadingLookups: false,
  total: 0,
};
